import React from "react";

interface ProductItemProps {
  id: number;
  price: number;
  size: string;
  quantity: number;
  gender: string;
  isLastRow?: boolean;
}

const ProductCard: React.FC<ProductItemProps> = ({
  id,
  price,
  size,
  quantity,
  gender,
  isLastRow = false,
}) => {
  const paddingTop = isLastRow ? "pt-3" : id <= 4 ? "pt-2" : "pt-3";

  const sizeClass =
    size === "s"
      ? "px-2 py-1"
      : size === "L"
      ? "px-3 py-1"
      : "px-2 py-1";

  const commonCardClasses = `card border border-dark ${paddingTop} pb-3 px-3 text-nowrap`;
  return (
    <div className={commonCardClasses}>
      <div className="d-flex justify-content-between align-items-start fw-bold fs-5 text-dark">
        {/* <img
          src="https://cdn.builder.io/api/v1/image/assets/1436b372cee44493a7d7daf0d0407938/6ca4de86aae62cb021aeb7b51e8e3680d157f513?placeholderIfAbsent=true"
          alt="Favorite"
          className="img-fluid mt-1"
          style={{ width: "12px" }}
        /> */}
        <img
          src="https://cdn.builder.io/api/v1/image/assets/1436b372cee44493a7d7daf0d0407938/aa4470f7b5060c4bf17b4178de6d0c7c2a0aedfa?placeholderIfAbsent=true"
          alt="Product"
          className="img-fluid mt-2"
          style={{ width: "44px" }}
        />
        <span>{quantity}</span>
      </div>
      <div className="d-flex align-items-center gap-2 mt-3">
        <div className="d-flex align-items-center fw-semibold text-dark">
          <img
            src="https://cdn.builder.io/api/v1/image/assets/1436b372cee44493a7d7daf0d0407938/602f2b6088024f98419b3753952b42f87de380cf?placeholderIfAbsent=true"
            alt="Price"
            className="img-fluid me-1"
            style={{ width: "12px" }}
          />
          <span>{price}</span>
        </div>
        <span className="text-secondary text-decoration-line-through">
          {/* {originalPrice} */}
        </span>
      </div>
      <div className={`mt-3 border border-dark rounded-pill text-dark text-center ${sizeClass}`}>
        {size}
      </div>
      <div className="mt-3 fw-semibold text-dark text-center text-wrap">
        Gender: {gender}
      </div>
    </div>
  );
};

export default ProductCard;
